import React from 'react';
import Button from '../../../components/ui/button';
import Icon from '../../../components/appIcon';
import Modal from 'components/ui/modal';

const DeleteConfirmationModal = ({ record, onClose, onConfirm }) => {
  return (
    <div className='!max-w-[200px]'>
      <Modal isOpen={true} onClose={onClose} width={'max-w-[550px]'}>
        <div className="bg-card rounded-lg   p-6">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-xl font-bold">Confirm Delete</h2>
            <Button variant="ghost" size="icon" onClick={onClose}>
              <Icon name="X" size={20} />
            </Button>
          </div>
          <p className="mb-6">
            Are you sure you want to delete the attendance record for {record?.employee?.name} on {record?.checkIn ? new Date(record.checkIn).toLocaleDateString() : ''}?
          </p>
          <div className="flex justify-end space-x-2">
            <Button variant="outline" onClick={onClose}>
              Cancel
            </Button>
            <Button variant="destructive" onClick={onConfirm}>
              Delete
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default DeleteConfirmationModal;